import React from 'react';
import './style.scss';
import CardsListCardHeader from '../../cardParts/header';
import CardsListCardDescription from '../../cardParts/description';
import CardsListCardFooter from '../../cardParts/footer';
import CardsListCardRewardsButton from '../../cardParts/rewards/button';
import CardsListCardRewardsContent from '../../cardParts/rewards/content';
import CardsListCardSelector from '../../cardParts/selector';
import clsx from 'clsx';
import useWindowSize from '../../../../Shared/hooks/useWindowSize';

export const CardsListGridCard = ({
  data,
  onSelect,
  isSelected,
  selectable,
  openRewards,
  rewardsOpened,
  dontShowCompare,
  t,
  children,
  style,
}) => {
  const {
    image,
    heading,
    text,
    hyperLink,
    featuresList,
    cashBackOffer,
    infoHyperLink,
    discountIconsList,
    discountVoucher,
    slideSectionLabel1,
    slideSectionLabel2,
    slideSectionIcons,
    slideSectionDescription,
  } = data.fields;

  const shouldRenderRewards =
    !!slideSectionLabel1?.value ||
    !!slideSectionLabel2?.value ||
    !!slideSectionDescription?.value ||
    !!slideSectionIcons?.length > 0;

  return (
    <div className={clsx('cards-list-grid-card', openRewards ? 'slide-opened' : '')} style={style}>
      {(selectable || isSelected) && dontShowCompare !== '1' && (
        <CardsListCardSelector
          t={t}
          isSelected={isSelected}
          onClick={onSelect}
          className={clsx('clgc-selector', isSelected && 'clgc-selector-active')}
        />
      )}
      <div>
        <CardsListCardHeader image={image} link={hyperLink} />
        <CardsListCardDescription
          heading={heading}
          text={text}
          features={featuresList}
          offer={cashBackOffer}
          link={infoHyperLink}
        />
      </div>
      <CardsListCardFooter
        heading={discountVoucher}
        icons={discountIconsList}
        onClick={openRewards}
        className="clgc-footer"
      ></CardsListCardFooter>
      {children}

      <div onClick={openRewards}>
        {shouldRenderRewards && <CardsListCardRewardsButton opened={rewardsOpened} />}
      </div>
    </div>
  );
};

export const CardsListGridPlaceholder = () => <div className="cards-list-grid-card-ph" />;

export const CardsListGridCardRewards = ({ data, rewardsOpened }) => {
  const { slideSectionLabel1, slideSectionLabel2, slideSectionIcons, slideSectionDescription } =
    data.fields;

  const shouldRenderRewards =
    !!slideSectionLabel1?.value ||
    !!slideSectionLabel2?.value ||
    !!slideSectionDescription?.value ||
    !!slideSectionIcons?.length > 0;

  const [sizeX] = useWindowSize();
  return (
    <div
      className={clsx(
        'cards-list-grid-card-rewards',
        rewardsOpened
          ? 'cards-list-grid-card-rewards-opened'
          : 'cards-list-grid-card-rewards-closed'
      )}
    >
      {shouldRenderRewards && (
        <CardsListCardRewardsContent
          sizeX={sizeX}
          opened={rewardsOpened}
          iconsList={slideSectionIcons}
          bottomHeading={slideSectionLabel2}
          description={slideSectionDescription}
          topHeading={slideSectionLabel1}
        />
      )}
    </div>
  );
};
